import { css } from 'styled-components';
import { getIconPath } from '../../../../../../../utils';
import { MY_BAG } from '../../../../SinglePageCheckout/views/SinglePageCheckoutPage.style.constants';

const styles = css`
  .product-tile-container {
    margin-top: ${(props) =>
      props.isMobileWebProductTile || !props.isDesktopProductTileCleanUpDisabled
        ? ` 0px;`
        : `20px;`};
    padding: ${(props) =>
      props.isDesktopProductTileCleanUpDisabled ? '24px 15px 24px 8px' : '28px 15px 28px 8px'};
    position: relative;
    border: ${(props) =>
      props.isMobileWebProductTile || !props.isDesktopProductTileCleanUpDisabled
        ? `none;`
        : `1px solid ${props.theme.colorPalette.gray[3200]}`};
    @media ${(props) => props.theme.mediaQuery.medium} {
      ${(props) =>
        props.isDesktopProductTileCleanUpDisabled
          ? `border: 1px solid ${props.theme.colorPalette.gray[3200]};
    border-radius: 10px;`
          : `border-bottom: 1px solid  ${props.theme.colorPalette.gray[500]};border-radius: 0px;`}
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-top: ${(props) => (props.isMobileWebProductTile ? ` 0px;` : `20px;`)};
      padding: 20px 15px 20px 8px;
      ${(props) =>
        !props.isMobileWebProductTile || props.isDesktopProductTileCleanUpDisabled
          ? `border: 1px solid ${props.theme.colorPalette.gray[3200]};
    border-radius: 10px;`
          : `border-bottom: 1px solid  ${props.theme.colorPalette.gray[3200]};border-radius: 0px;`}
    }
  }
  .crossDeleteIconBag {
    float: right;
    cursor: pointer;
    padding-top: 0px;
    position: absolute;
    top: ${(props) =>
      props.isDesktopProductTileCleanUpDisabled ? props.theme.spacing.ELEM_SPACING.MED : '26px'};
    right: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    z-index: 2;
    img {
      display: block;
    }
  }

  .text-capitalize {
    text-transform: capitalize;
  }
  .attribute-container {
    display: flex;
    ${(props) => !props.isDesktopProductTileCleanUpDisabled && `justify-content: space-between;`}
  }
  .price-qty-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 16px;
    margin-top: 14px;

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-right: 1px;
      ${(props) => (props.isMobileWebProductTile ? 'margin-top:0px' : 'margin-top:14px')};
    }
  }
  .price-tag {
    color: #c8102e;
    text-align: right;
    font-family: Nunito;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    margin-top: 4px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      text-align: ${(props) => (props.isMobileWebProductTile ? 'left' : 'right')};
    }
  }

  .was-price-tag {
    color: #979797;
    font-family: Nunito;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-decoration: line-through;
    text-align: end;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      text-align: ${(props) => (props.isMobileWebProductTile ? 'start' : 'end')};
    }
  }

  .quantity-ddl {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: ${(props) => (props.isMobileWebProductTile ? '40px' : '49px;')};
    }
  }
  .color-fit-size-separator {
    padding: 0 10px;
    color: ${(props) => props.theme.colorPalette.BUTTON.WHITE.FOCUS};
    display: inline-block;
  }
  .product-name-tag {
    width: 80%;
    display: block;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 90%;
    }
  }

  .bag-product-detail-wrapper {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    .label-responsive {
      width: 49px;
      margin-right: 0px;
      padding-right: 0px;
    }
    .value-responsive {
      padding-left: ${(props) => (props.isMobileWebProductTile ? '0px' : '3px')};
      margin-right: 0px;
      text-align: ${(props) => (props.isMobileWebProductTile ? 'left' : 'right')};
    }
    .label-responsive-wrapper {
      padding-top: 2px;
      display: flex;
      padding-right: 0px;
      /* stylelint-disable */
      span:not(.list-price) {
        font-size: ${(props) => props.theme.fonts.fontSize.listmenu.small}px;
      }
      span.was-price {
        font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      }
      /* stylelint-enable */
    }
    .responsive-edit-css {
      text-decoration: underline;
      padding-top: 0px;
      cursor: pointer;
      display: inline-flex;
      justify-content: flex-start;
    }
  }
  .upc-container {
    margin-top: ${(props) => (props.isDesktopProductTileCleanUpDisabled ? '0px' : '4px')};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: none;
    }
  }
  .product-detail-row {
    width: 100%;
  }
  .brand-image {
    text-align: center;
    width: ${(props) => (props.newMiniBag ? '45px' : '55px')};
  }
  .product-brand-img-wrapper {
    position: relative;
    align-items: center;
    width: 103px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 0 12px 0 4px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 105px;
      padding: 0 ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
    & .brand-image {
      width: 60px;
    }
  }
  .product-tile-wrapper {
    font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    flex-wrap: nowrap;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      position: relative;
    }
    & .product-detail-row {
      margin: 0;
    }
    & .list-price {
      padding-left: 5px;
    }
    & .product-brand-img-wrapper {
      position: relative;
      align-items: center;
      width: ${(props) => (props.isMobileWebProductTile ? '80px' : '103px')};
      @media ${(props) => props.theme.mediaQuery.medium} {
        padding: 0 12px 0 4px;
      }
      @media ${(props) => props.theme.mediaQuery.large} {
        width: 105px;
        padding: 0 ${(props) => props.theme.spacing.ELEM_SPACING.MED};
      }
      & .brand-image {
        width: ${(props) => (props.isDesktopProductTileCleanUpDisabled ? '60px' : '68px')};
      }
    }
    & .product-brand-img-wrapper-sfl {
      @media ${(props) => props.theme.mediaQuery.large} {
        height: auto;
      }
    }
    .color-size-fit-label {
      width: 49px;
    }
    .bag-product-detail-wrapper {
      font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
      display: flex;
      flex-direction: column;
      position: relative;
      width: 100%;
      .label-responsive {
        width: 49px;
        margin-right: 0px;
        padding-right: 0px;
      }
      .value-responsive {
        padding-left: ${(props) => (props.isMobileWebProductTile ? '0px' : '3px')};
        margin-right: 0px;
        text-align: ${(props) => (props.isMobileWebProductTile ? 'left' : 'right')};
      }
      .label-responsive-wrapper {
        padding-top: 2px;
        display: flex;
        padding-right: 0px;
        /* stylelint-disable */
        span:not(.list-price) {
          font-size: ${(props) => props.theme.fonts.fontSize.listmenu.small}px;
        }
        span.was-price {
          font-size: ${(props) => props.theme.typography.fontSizes.fs14};
        }
        /* stylelint-enable */
      }
      .responsive-edit-css {
        text-decoration: underline;
        padding-top: 0px;
        cursor: pointer;
        display: inline-flex;
        justify-content: flex-start;
      }
    }
    .color-fit-size-separator {
      padding: 0 10px;
      color: ${(props) => props.theme.colorPalette.BUTTON.WHITE.FOCUS};
      display: inline-block;
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      .save-for-later-label {
        margin: ${(props) =>
          props.isMobileWebProductTile ? '0' : `${props.theme.spacing.ELEM_SPACING.XS_1} 0`};
        width: 100%;
        left: 10px;
        margin-top: 0;
      }
      .color-map-size-fit {
        display: inline-grid;
      }
      .responsive-edit-css {
        text-decoration: underline;
        cursor: pointer;
      }
      .bag-product-detail-wrapper {
        position: static;
      }
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      .color-fit-size-desktop {
        width: auto;
      }
    }
    @media ${(props) => props.theme.mediaQuery.mobile} {
      .save-for-later-label {
        left: 3px;
      }
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      .save-for-later-label {
        left: 3px;
      }
    }
    .price-label {
      color: ${(props) => props.theme.colorPalette.red[500]};
      font-size: ${(props) => props.theme.typography.fontSizes.fs16};
      text-align: ${(props) => (props.isMobileWebProductTile ? 'left' : 'right')};
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        ${(props) =>
          props.isBagPageSflSection && !props.isMobileWebProductTile
            ? 'top: -30px; position: absolute;'
            : `${
                props.isMobileWebProductTile
                  ? 'margin-top: 0px; position: unset;'
                  : 'margin-top: 12px;'
              }`}
      }
      @media ${(props) => props.theme.mediaQuery.large} {
        margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
        min-width: 75px;
      }
    }
    .price-label-bag {
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        ${(props) =>
          props.isHideMeatBallAbTest
            ? `margin-top:0;`
            : `${
                props.isMobileWebProductTile
                  ? 'position:relative; top: 0px;  right: 0px;'
                  : 'position:relative; top: 0px;  right: 4px;'
              }`}
      }
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      .elem-pt-MED {
        padding: 0px;
        position: relative;
        top: 14px;
      }
    }
    .original-price-label {
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      display: block;
      height: 18px;
    }
  }

  .dam-image-review-page {
    width: 55px;
    ${(props) =>
      props.isSinglePageCheckout
        ? `
      width: ${MY_BAG.IMG_WIDTH.MOBILE};
      height: ${MY_BAG.IMG_HEIGHT.MOBILE};
      @media ${props.theme.mediaQuery.medium} {
        width: ${MY_BAG.IMG_WIDTH.TABLET};
        height: ${MY_BAG.IMG_HEIGHT.TABLET};
      }
      @media ${props.theme.mediaQuery.large} {
        width: ${MY_BAG.IMG_WIDTH.DESKTOP};
        height: ${MY_BAG.IMG_HEIGHT.DESKTOP};
      }
    `
        : ''}
  }
  .align-product-img {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    @media ${(props) => props.theme.mediaQuery.large} {
      justify-content: space-between;
    }
  }
  .imageWrapper {
    position: relative;
    width: 116px;
    text-align: center;
  }

  .dam-image-HW {
    max-height: ${(props) => (props.isDesktopProductTileCleanUpDisabled ? '124px' : '140px')};
    width: ${(props) => (props.isDesktopProductTileCleanUpDisabled ? '104px' : '112px')};

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      max-height: 96px;
      width: 76px;
    }

    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      max-height: 96px;
      width: 89px;
    }
  }

  .color-fit-size-separator-mobile {
    padding: 0 5px;
    color: ${(props) =>
      props.isMobileWebProductTile
        ? props.theme.colorPalette.gray[3200]
        : props.theme.colorPalette.BUTTON.WHITE.FOCUS};
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      padding: 0 10px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: ${(props) => (props.isMobileWebProductTile ? '0 12px' : '0 3px')};
    }
  }

  .size-fit-text {
    font-size: 14px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 12px;
    }
  }
  .productImgBrand {
    width: 100%;
  }
  #quantity.select__input {
    font-size: 13px;
    ${(props) =>
      props.isMobileWebProductTile &&
      `border: none;
    padding-left: 0px;
    width: 80%;
    padding-top: 10px;
    background: url(${getIconPath('dropdown-icon', props)}) no-repeat right ${
        '3px' || '0px'
      } bottom ${'12px' || props.theme.spacing.ELEM_SPACING.SM};`}
  }
`;

export default styles;
